// extracted by css-extract-rspack-plugin
export default {"container":"_488fb2d4","separator":"_a600f66e","title":"_fb721e53"};